module.exports = "https://deal.freetls.fastly.net/consumer/common/media/step-3.e5b6cf8a.mp4";